// Regras do menu lateral do Nexus Chat que não dependem de tela: qual item do
// painel está ativo e quais itens a pessoa pode ver. Os itens são os do menu do
// Chatwoot (Sidebar.vue), com as mesmas permissões das rotas.

// O item ativo entre as folhas do módulo, na mesma ordem de preferência do
// SidebarGroup do core: `ativoQuando` (nossos filtros), caminho igual, activeOn
// (com os parâmetros da rota), e por fim o começo do caminho.
export const encontraAtivo = (folhas, route, resolvePath) => {
  const nossa = folhas.find(folha => folha.ativoQuando?.());
  if (nossa) return nossa;
  const comuns = folhas.filter(folha => !folha.ativoQuando);

  const mesmoCaminho = comuns.find(
    folha => folha.to && route.path === resolvePath(folha.to)
  );
  if (mesmoCaminho) return mesmoCaminho;

  const porActiveOn = comuns.filter(folha =>
    folha.activeOn?.includes(route.name)
  );
  if (porActiveOn.length) {
    return (
      porActiveOn.find(folha =>
        Object.keys(folha.to?.params || {}).every(
          chave =>
            String(folha.to.params[chave]) === String(route.params[chave])
        )
      ) ?? porActiveOn[0]
    );
  }

  return comuns.find(folha => {
    if (!folha.to) return false;
    const caminho = resolvePath(folha.to);
    return route.path === caminho || route.path.startsWith(`${caminho}/`);
  });
};

export const folhasDe = itens => itens.flatMap(item => item.children || item);

// Os filhos que a pessoa pode abrir (grupo só com algum filho permitido).
export const visiveis = (itens, permitido) =>
  itens
    .map(item =>
      item.children
        ? {
            ...item,
            children: item.children.filter(
              filho => filho.to && permitido(filho.to)
            ),
          }
        : item
    )
    .filter(item =>
      item.children ? item.children.length > 0 : item.to && permitido(item.to)
    );
